// Mock data for QOLDO landing page

export const siteContent = {
  brand: {
    name: "QOLDO",
    logo: "https://customer-assets.emergentagent.com/job_ee72ca91-27d3-4b37-bb13-b6f1d5a13d4d/artifacts/hd0fv4vm_Qoldo%20Logo%20Black%20800%20x%20500%20px.png",
    loginUrl: "https://app.qoldo.com"
  },
  hero: {
    headline: "Daily microlearning for frontline teams",
    subheadline: "Qoldo helps organizations train people in the rhythm of their work — one minute a day, swipe-based, and actually remembered.",
    context: "Built for retail, healthcare and service environments.",
    cta: "Request a demo"
  },
  problem: {
    title: "The challenge of training today",
    body: [
      "Training doesn't fail because people don't care. It struggles because it no longer fits into the rhythm of everyday work.",
      "Frontline teams are expected to learn through long sessions, infrequent moments and complex systems — while their operational responsibilities continue without pause."
    ],
    results: [
      "Low adoption",
      "Low retention",
      "High frustration"
    ],
    conclusion: "Many training systems are built for compliance. Very few are designed around human behavior."
  },
  solution: {
    title: "Training that fits the scroll — and the workday",
    intro: "Qoldo replaces long training sessions with short, daily learning moments.",
    highlights: [
      "One minute a day.",
      "Swipe-based.",
      "Mobile-first."
    ],
    description: "Each session consists of a few focused cards and a single question — designed to create habit, repetition and recall.",
    benefits: [
      "No disruption.",
      "No training days lost.",
      "Just learning that actually happens."
    ]
  },
  howItWorks: {
    title: "How Qoldo works in practice",
    columns: [
      {
        title: "For teams",
        points: [
          "One short session per day",
          "No complex logins",
          "Done in under a minute"
        ]
      },
      {
        title: "For trainers",
        points: [
          "Create content in minutes",
          "No LMS setup",
          "Immediate feedback"
        ]
      },
      {
        title: "For managers",
        points: [
          "See adoption and completion",
          "No operational downtime",
          "Real usage, real data"
        ]
      }
    ]
  },
  proof: {
    title: "Built from real frontline environments",
    body: [
      "Qoldo is not a theoretical platform.",
      "The product is live, actively used, and rolling out in real frontline teams within large European organizations.",
      "It was designed from the ground up in environments where time, attention and operational flow matter."
    ]
  },
  forWho: {
    title: "Who Qoldo is for",
    list: [
      "Retail organizations",
      "Healthcare environments",
      "Hospitality and service teams"
    ],
    body: "Anywhere training needs to happen daily — without stopping the operation."
  },
  closing: {
    body: "Qoldo is not a learning platform. It's a daily learning ritual.",
    cta: "Request a demo"
  }
};
